module.exports = __webpack_public_path__ + "static/img/thumb-forest-lands.22f07f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-forest-lands.png
// module id = 88
// module chunks = 0